<template>
<div class="container mb-4">
  <div class="wrapper">
    <DataTable :value="SUB_INVOICES" :selection.sync="selectedOrder" @row-select="invoiceDetails(selectedOrder)" selectionMode="single">
      <Column header="Fakturanummer">
        <template #body="slotProps">
          {{ isimGenerateId(slotProps.data.id) }}
        </template>
      </Column>
      <Column field="type" header="Fakturatyp" />
      <Column field="name" header="Namn" />
    </DataTable>
  </div>
</div>
</template>

<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

import { InvoiceSubIdMixin } from '@/mixins/InvoiceSubIdMixin'

import { mapGetters } from 'vuex'

export default {
  mixins: [InvoiceSubIdMixin],
  components: {
    DataTable,
    Column
  },
  data () {
    return {
      selectedOrder: null
    }
  },
  async mounted () {
    await this.$store.dispatch('GET_SUB_INVOICES')
  },
  computed: {
    ...mapGetters(['SUB_INVOICES'])
  },
  methods: {
    invoiceDetails (invoice) {
      switch (invoice.type) {
        case 'feralco':
          this.$router.push({ name: 'InvoiceFeralcoCreate', params: { id: invoice.parentId, archive: true } })
          break
        case 'feralcoIntern':
          this.$router.push({ name: 'InvoiceFeralcoInternCreate', params: { id: invoice.parentId, archive: true } })
          break
        case 'hydro':
          this.$router.push({ name: 'InvoiceHydroCreate', params: { id: invoice.parentId, archive: true } })
          break
        default:
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Invoices/InvoiceSubArchive.vue